import {
  DEFAULT_REST_BETWEEN_EXERCISES,
  type ExerciseInWorkout,
  type ProgramWorkout,
} from "@fitness-app/data-models/entities/TrainingProgram";

/**
 * Rest after an exercise (or after the superset whose last exercise this is): the exercise's own
 * override, then the workout default, then DEFAULT_REST_BETWEEN_EXERCISES. 0 means no rest.
 */
export const getRestAfterExercise = (
  exercise: Pick<ExerciseInWorkout, "restAfterExercise"> | null | undefined,
  workout: Pick<ProgramWorkout, "restBetweenExercises"> | null | undefined,
): number => exercise?.restAfterExercise ?? workout?.restBetweenExercises ?? DEFAULT_REST_BETWEEN_EXERCISES;
